import { useQuery } from "@apollo/client";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HourglassFullIcon from "@material-ui/icons/HourglassFull";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import React from "react";

export const ResourceRollupStatusListItem = ({
  id,
  name,
  short_name,
  status_archive,
  status_non_archive,
  status_historical,
  error,
  loading,
}: {
  id?: string;
  name?: string;
  short_name?: string;
  status_archive?: number;
  status_non_archive?: number;
  status_historical?: number;
  error?: string;
  loading?: boolean;
}) => {
  const status = Math.max(status_archive || 0, status_non_archive || 0, status_historical || 0);
  return (
    <Paper>
      <Box position="relative" width="100%">
        <Box
          p={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <ListItemText
            primary={loading ? <Skeleton width={180} /> : name}
          // secondary={
          //   loading ? (
          //     <Skeleton width={140} />
          //   ) : (
          //     <ResourceSecondaryText
          //       block={block}
          //       current={current}
          //       error={error}
          //     />
          //   )
          // }
          />
          <Tooltip disableHoverListener title={<Box>
            <Box display="flex" flexWrap="nowrap">
              <Typography>Node</Typography>
              <Box flexGrow={1} />
              <ResourceStatusText status={status_non_archive || 0} />
              <ResourceStatusIcon status={status_non_archive || 0} />
            </Box>
            <Box display="flex" flexWrap="nowrap">
              <Typography>Archive Node</Typography>
              <Box flexGrow={1} />
              <ResourceStatusText status={status_archive || 0} />
              <ResourceStatusIcon status={status_archive || 0} />
            </Box>
            <Box display="flex" flexWrap="nowrap">
              <Typography>Historical</Typography>
              <Box flexGrow={1} />
              <ResourceStatusText status={status_historical || 0} />
              <ResourceStatusIcon status={status_historical || 0} />
            </Box>
          </Box>}>
            <Box display="flex">
              <ResourceStatusText status={status} />
              <ResourceStatusIcon status={status} />
            </Box>
          </Tooltip>
        </Box>
      </Box>
    </Paper>
  );
};

const ResourceStatusText = ({
  status,
}: {
  status: number;
}) => {
  return <Box mx={1}>
    <Typography color={getColor(status) || 'initial'} style={{ textTransform: "capitalize" }}>
      {getText(status)}
    </Typography>
  </Box>
}

const ResourceStatusIcon = ({
  status,
}: {
  status: number;
}) => {
  switch (status) {
    case 1:
      return <CheckCircleIcon color={getColor(status) || 'action'} />;
    case 2:
      return <HourglassFullIcon color={getColor(status) || 'action'} />;
    case 3:
      return <CancelOutlinedIcon color={getColor(status) || 'action'} />;
    default:
      return null;
  }
};

function getText(status: number) {
  switch (status) {
    case 1: return 'Success'
    case 2: return 'Syncing'
    case 3: return 'Fail'
    default: return ''
  }
}
function getColor(status: number) {
  switch (status) {
    case 1: return 'primary'
    case 2: return 'secondary'
    case 3: return 'error'
  }
}
